import { isValid, type Locale } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

/** Merchant-facing wall clock: UTC+3 (Moscow), whatever the browser timezone is. */
export const DISPLAY_TIME_ZONE = 'Europe/Moscow';

export const parseApiDate = (value: string | Date | number | null | undefined): Date | null => {
  if (value == null || value === '') return null;
  if (value instanceof Date) return isValid(value) ? value : null;

  if (typeof value === 'number') {
    const ms = value < 1e12 ? value * 1000 : value;
    const date = new Date(ms);
    return isValid(date) ? date : null;
  }

  const date = new Date(value);
  return isValid(date) ? date : null;
};

export const formatInDisplayZone = (date: Date, pattern: string, options?: { locale?: Locale }): string =>
  formatInTimeZone(date, DISPLAY_TIME_ZONE, pattern, options);

export const formatDateTime = (
  value: string | Date | number | null | undefined,
  pattern = 'dd.MM.yyyy HH:mm:ss',
): string => {
  const date = parseApiDate(value);
  if (!date) return '-';
  return formatInDisplayZone(date, pattern);
};

/** Calendar date (tables, filters, report dates). */
export const formatDate = (
  value: string | Date | number | null | undefined,
  pattern = 'dd.MM.yyyy',
): string => formatDateTime(value, pattern);

/** Compact date for dense tables in modals. */
export const formatTableDateTime = (
  value: string | Date | number | null | undefined,
): string => formatDateTime(value, 'dd.MM.yy HH:mm');
